import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import lang from './lang/lang'

import VModal from 'vue-js-modal'

import functionsMx from "./mixins/functions";

Vue.use(VModal);
Vue.mixin(functionsMx);

Vue.config.productionTip = false

const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


